var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div ng-repeat=\"delivery in customer.deliveries\" ng-class=\"{ cancelledProduct: delivery.status === 'cancelled' }\"><span ng-class=\"{ 'has-comment': delivery.comment }\" tooltip=\"deliveryStatusTooltipTemplate\" class=\"{{ delivery.status }} delivery-status\"></span>{{ delivery.product }}<span ng-show=\"(delivery.productCount &gt; 1 || delivery.adhoc) &amp;&amp; delivery.productCountAdjusted === null\"> ({{ delivery.productCount }})</span><span ng-show=\"(delivery.productCount &gt; 1 || delivery.adhoc) &amp;&amp; delivery.productCountAdjusted &gt; 0\"> ({{ delivery.productCountAdjusted }}/{{ delivery.productCount }})</span></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/statusDeliveries.jade
 ** module id = 108
 ** module chunks = 1
 **/